import { render, staticRenderFns } from "./ProductsByCategory.vue?vue&type=template&id=49a0fe3a"
import script from "./ProductsByCategory.vue?vue&type=script&lang=js"
export * from "./ProductsByCategory.vue?vue&type=script&lang=js"
import style0 from "./ProductsByCategory.vue?vue&type=style&index=0&id=49a0fe3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports